// extracted by mini-css-extract-plugin
export default {"gallery":"FacilityImages_gallery__DrTZx","card":"FacilityImages_card__RTcti","image":"FacilityImages_image__UCLuz","title":"FacilityImages_title__YVJ-Y"};